// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info[data-v-06ea10ce]{margin:5px 0 6px;padding:16px}.info[data-v-06ea10ce] .name{font-size:18px}.actions[data-v-06ea10ce]{display:flex;flex-direction:row;align-items:center;justify-content:center}.actions>*[data-v-06ea10ce]{flex:auto 0 0}.actions[data-v-06ea10ce] >:not(:last-child){margin-right:8px}", ""]);
// Exports
module.exports = exports;
